<template src='./conclusion.html'></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import FormSetup from '@/components/misc/form-setup/FormSetup'

const ORGANIZATION_ID = 'root.proposer info.proposer organization.proposer'

export default {
  components: {
    'form-setup': FormSetup
  },
  data () {
    return {
      autoCompleteUrl_budgetId: Vue.$apiConfig.budgetUsersGet,
      help: {
        form: Vue.$helpConfig.projectFormConclusion
      },
      expensesCalculation: null,
      formMarkdownElements: [
        {
          editor: 'root.basic info.notes',
          element: 'root[basic info][notes]',
          name: 'basic info.notes'
        },
        {
          editor: 'root.basic info.measures',
          element: 'root[basic info][measures]',
          name: 'basic info.measures'
        },
        {
          editor: 'root.еxpenses.totals.notes',
          element: 'root[еxpenses][totals][notes]',
          name: 'expenses.totals.notes'
        },
        {
          editor: 'root.еxpenses.deviation.notes',
          element: 'root[еxpenses][deviation][notes]',
          name: 'еxpenses.deviation.notes'
        },
        {
          editor: 'root.other.notes',
          element: 'root[other][notes]',
          name: 'other.notes'
        },
        {
          editor: 'root.other.comment',
          element: 'root[other][comment]',
          name: 'other.comment'
        }
      ]
    }
  },
  methods: {
    fetchOrganization (query) {
      const queryParamName = '?filter[search]=' + query
      const url = this.autoCompleteUrl_budgetId
      const cancel = new Promise((resolve) => (this.cancel = resolve))
      const request = this.$http.get(url + queryParamName)
      return Promise.race([cancel, request])
    },
    initialOrganizationAutoComplete () {
      this.addNewAutocomplete(ORGANIZATION_ID, this.fetchOrganization)
    },
    setupPage () {
      if (this.$refs.setup) {
        this.$refs.setup.loading = true
      }
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.$route.params.phaseFormId)
        .then(
          response => {
            const form = response.data.payload
            this.$refs.setup.formName = form.name
            this.$refs.setup.project = response.data.additionalInformation
            this.$refs.setup.formStatus = form.status
            this.$refs.setup.formCode = form.code
            this.$refs.setup.formatRevisions(form.inputJsonRevisions, 'zavrsni')
            const newForm = this.initialDataSetup(form, response.data.additionalInformation)
            this.$refs.setup.pif = JSON.parse(form.json)
            this.$refs.setup.initialSchema = this.$refs.setup.pif.schema
            this.$refs.setup.initialConfig = this.$refs.setup.pif.config
            this.initializeEditor()
            this.$refs.setup.initialVal = newForm === '{}' ? this.$refs.setup.editor.getValue() : JSON.parse(newForm)
            this.$refs.setup.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.$refs.setup.loading = false
          }
        )
    },
    changeRevision (selectedRevision) {
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.$route.params.phaseFormId + '/revision/' + selectedRevision)
        .then(
          response => {
            this.logConsole(response)
            const revision = response.data.payload
            this.$refs.setup.pif = JSON.parse(revision.json)
            this.$refs.setup.initialSchema = this.$refs.setup.pif.schema
            this.$refs.setup.initialConfig = this.$refs.setup.pif.config
            this.$refs.setup.initialVal = revision.inputJson ? JSON.parse(revision.inputJson) : null
            this.initializeEditor()
            history.pushState({}, null, ('/projects/' + this.$refs.setup.projectCode + '/phases/' + Number(this.$refs.setup.projectPhaseId) + '/forms/zavrsni/id/' + Number(this.$refs.setup.phaseFormId) + '/revision/' + this.$refs.setup.revision.revision))
          },
          error => {
            this.formatErrorResponse(error)
            this.$refs.setup.loading = false
          }
        )
    },
    initializeEditor () {
      this.$refs.setup.configureEditor()
      this.initialOrganizationAutoComplete()

      this.$refs.setup.editor.on('ready', () => {
        this.initialMarkdownControls()
        if (this.$refs.setup.initialVal) {
          this.$refs.setup.saveJsonValues(this.$refs.setup.initialVal)
        }
        this.$refs.setup.manageInput()

        this.initialOrganizationAutoComplete()
      })

      this.$refs.setup.editor.on('change', () => {
        this.checkChanges()
      })
      console.log(this.$refs.setup.editor)
    },
    initialDataSetup (form, addData) {
      if (form.inputJson === '{}') {
        var val = JSON.parse(form.inputJson)
        const concData = form.conclusionAddData
        const sourcesAdd = JSON.parse(concData.sources)
        const date1 = new Date(concData.plannedDateEnd)
        const date2 = new Date(concData.realDateEnd)
        const diffInTime = date2.getTime() - date1.getTime()
        const diffInDays = Math.round(diffInTime / (1000 * 3600 * 24))
        val['basic info'] = JSON.parse('{}')
        val['basic info']['project name'] = addData.nameFormJson
        val['proposer info'] = JSON.parse('{}')
        val['proposer info']['authorized organization'] = JSON.parse('{}')
        val['proposer info']['proposer organization'] = JSON.parse('{}')
        val['proposer info']['authorized organization'].authorized = addData.organizationName
        val['proposer info']['proposer organization'].proposer = addData.proposerOrganizationName
        val['еxpenses'] = JSON.parse('{}')
        val['еxpenses'].totals = JSON.parse('{}')
        val['еxpenses'].totals['estimated planned'] = concData.plannedExpenses
        val['еxpenses'].totals['estimated realization'] = concData.plannedRealization
        val['еxpenses'].totals['actual realization'] = this.formatAmount(concData.realExpense)
        val['basic info'].delays = JSON.parse('{}')
        val['basic info'].delays['implementation start'] = concData.dateStart
        val['basic info'].delays['planned completion'] = concData.plannedDateEnd
        val['basic info'].delays['actual end'] = concData.realDateEnd
        val['basic info'].delays['exceeding deadline'] = diffInDays
        val['basic info'].['approval date'] = concData.boardAccepted
        val['еxpenses'].funding = JSON.parse('{}')
        val['еxpenses'].funding.sources = []
        // console.log(concData.sources.length)
        for (let i = 0; i < sourcesAdd.length; i++) {
          console.log('{ "diff": "","name": "","other": "","source": "' + sourcesAdd[i].source + '","аctual": "' + sourcesAdd[i]['local amount'] + '","estimate": "","adjustment": "" }')
          val['еxpenses'].funding.sources.push(JSON.parse('{ "diff": "","name": "","other": "","source": "' + sourcesAdd[i].source + '","аctual": "","estimate": "' + sourcesAdd[i]['local amount'] + '","adjustment": "" }'))
        }
        // console.log(val)
        return JSON.stringify(val)
      } else {
        return form.inputJson
      }
    },
    checkChanges () {
      const val = this.$refs.setup.initialVal
      var values = this.$refs.setup.editor.getValue()
      for (let index = 0; index < val.еxpenses.funding.sources.length; index++) {
        if (val.еxpenses.funding.sources[index].name === undefined || val.еxpenses.funding.sources[index].name === '') {
          val.еxpenses.funding.sources[index].name = ''
          if (values.еxpenses.funding.sources) {
            if (values.еxpenses.funding.sources[index]) {
              values.еxpenses.funding.sources[index].name = ''
            }
          }
        }
      }

      for (var i = 0; i < this.$refs.setup.markdownElements.length; i++) {
        const elem = this.$refs.setup.markdownElements[i].name
        var chars = elem.split('.')
        var value = this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[i].editor) ? this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[i].editor).simplemde_instance.value() : ''
        if (chars.length === 2) {
          values[chars[0]][chars[1]] = value
        } else {
          if (chars[1] === 'totals') {
            if (values['еxpenses'].totals) {
              // eslint-disable-next-line dot-notation
              values['еxpenses']['totals']['notes'] = value
            }
          } else {
            // eslint-disable-next-line dot-notation
            if (values['еxpenses']['deviation']) {
              values['еxpenses'].deviation.notes = value
            }
          }
        }
      }
      if (val.еxpenses.deviation !== undefined) {
        if (val.еxpenses.deviation.deviated === 'Не') {
          val.еxpenses.deviation = {
            deviated: 'Не',
            notes: ''
          }
        }
      }
      if (val['basic info'].delayed === 'Не') {
        val['basic info'].notes = ''
        val['basic info'].measures = ''
      }
      if (val.other !== undefined) {
        if (val.other.questions === 'Не') {
          val.other = {
            questions: 'Не',
            notes: ''
          }
        }
      }
      delete val['expenses.totals.notes']
      delete val['еxpenses.deviation.notes']
      delete val['basic info.measures']
      delete val['basic info.notes']
      delete val['other.notes']

      this.$refs.setup.formChanged = !this.deepEqual(val, values)
      // console.log(this.$refs.setup.editor)
      const еxpensesTotal = this.$refs.setup.editor.getEditor('root.еxpenses.funding.sources totals')
      еxpensesTotal.header.innerHTML = this.formatExpensesTotalCalculation(values)
      const date1 = new Date(values['basic info'].delays['planned completion'])
      const date2 = new Date(values['basic info'].delays['actual end'])
      const diffInTime = date2.getTime() - date1.getTime()
      const diffInDays = Math.round(diffInTime / (1000 * 3600 * 24))
      this.$refs.setup.editor.getEditor('root.basic info.delays.exceeding deadline').setValue(diffInDays)
    },
    initialMarkdownControls () {
      for (var j = 0; j < this.$refs.setup.markdownElements.length; j++) {
        this.$refs.setup.configureMarkdownElement(this.$refs.setup.markdownElements[j])
        if (this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[j].editor)) {
          this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[j].editor).simplemde_instance.codemirror.on('changes', () => {
            this.checkChanges()
          })
        }
      }
    },
    addNewAutocomplete (name, fetchFunction) {
      this.$refs.setup.editor.editors[name].options.autocomplete.search = function (input) {
        return new Promise(function (resolve) {
          if (input.length < 2) {
            return resolve([])
          }
          fetchFunction(input).then(function (response) {
            return response.json()
          }).then(function (data) {
            resolve(data.payload)
          })
        })
      }

      this.formatAutocompleteResult(name)
    },
    formatAutocompleteResult (name) {
      this.$refs.setup.editor.editors[name].options.autocomplete.getResultValue = (result) => {
        return name.includes('currency') ? result.exchangeCode + ' ' + this.formatAmount(result.exchangeRate) : result.id + ' - ' + result.name
      }
      this.$refs.setup.editor.editors[name].options.autocomplete.renderResult = (result, props) => {
        const title = name.includes('currency') ? result.exchangeCode : result.id
        const subtitle = name.includes('currency') ? this.formatAmount(result.exchangeRate) : result.name

        return ['<li ' + props + '>',
          '<div class="wiki-title">' + title + '</div>',
          '<div class="wiki-snippet"><small>' + subtitle + '<small></div>',
          '</li>'].join('')
      }
    },
    getExpensesCalculation (values) {
      this.expensesCalculation = {
        totalEstimate: '',
        totalAdjustment: '',
        totalOther: '',
        totalActual: '',
        totalDiff: '',
        percentageEstimate: '',
        percentageAdjustment: '',
        percentageOther: '',
        percentageActual: '',
        percentageDiff: ''
      }
      const sources = values.еxpenses.funding.sources
      if (sources) {
        let totalEstimate = this.sum(sources.map(item => item.estimate))
        let totalAdjustment = this.sum(sources.map(item => item.adjustment))
        let totalOther = this.sum(sources.map(item => item.other))
        let totalActual = this.sum(sources.map(item => item.аctual))
        let totalDiff = this.sum(sources.map(item => item.diff))

        totalEstimate = totalEstimate === '' ? 0 : parseFloat(totalEstimate)
        totalAdjustment = totalAdjustment === '' ? 0 : parseFloat(totalAdjustment)
        totalOther = totalOther === '' ? 0 : parseFloat(totalOther)
        totalActual = totalActual === '' ? 0 : parseFloat(totalActual)
        totalDiff = totalDiff === '' ? 0 : parseFloat(totalDiff)

        this.expensesCalculation = {
          totalEstimate: totalEstimate > 0 ? this.formatAmount(totalEstimate) : '',
          totalAdjustment: totalAdjustment > 0 ? this.formatAmount(totalAdjustment) : '',
          totalOther: totalOther > 0 ? this.formatAmount(totalOther) : '',
          totalActual: totalActual > 0 ? this.formatAmount(totalActual) : '',
          totalDiff: totalDiff > 0 ? this.formatAmount(totalDiff) : '',
          percentageEstimate: totalEstimate > 0 ? this.formatAmount(100) : '',
          percentageAdjustment: totalAdjustment > 0 && totalEstimate > 0 ? this.formatAmount(totalAdjustment / totalEstimate * 100) : '-',
          percentageOther: totalOther > 0 && totalEstimate > 0 ? this.formatAmount(totalOther / totalEstimate * 100) : '-',
          percentageActual: totalActual > 0 && totalEstimate > 0 ? this.formatAmount(totalActual / totalEstimate * 100) : '-',
          percentageDiff: totalDiff > 0 && totalEstimate > 0 ? this.formatAmount(totalDiff / totalEstimate * 100) : '-'
        }
      }
    },
    formatExpensesTotalCalculation (values) {
      this.getExpensesCalculation(values)
      return `<div class="table_wrapper">
                <table id ="sumExpenses">
                  <thead style="text-align:right">
                    <tr>
                      <th></th>
                      <th>Процена у време почетка реализације  пројекта</th>
                      <th>Прилагођавање пројекта</th>
                      <th>Остале промене</th>
                      <th>Укупан трошак</th>
                      <th>Трошкови смањење/прекорачење</th>
                    </tr>
                  </thead>
                  <tbody style="text-align:right">
                    <tr>
                      <td>Укупно</td>
                      <td>` + this.expensesCalculation.totalEstimate + `</td>
                      <td>` + this.expensesCalculation.totalAdjustment + `</td>
                      <td>` + this.expensesCalculation.totalOther + `</td>
                      <td>` + this.expensesCalculation.totalActual + `</td>
                      <td>` + this.expensesCalculation.totalDiff + `</td>
                    </tr>
                    <tr>
                      <td>%</td>
                      <td>` + this.expensesCalculation.percentageEstimate + `</td>
                      <td>` + this.expensesCalculation.percentageAdjustment + `</td>
                      <td>` + this.expensesCalculation.percentageOther + `</td>
                      <td>` + this.expensesCalculation.percentageActual + `</td>
                      <td>` + this.expensesCalculation.percentageDiff + `</td>
                    </tr>
                  </tbody>
                </table>
              </div>`
    }
  },
  created () {
    this.setupPage()
    EventBus.$on('setupPage', () => {
      if (this.$refs && this.$refs.setup) {
        this.$refs.setup.revision = {
          revision: null
        }
      }
      this.setupPage()
    })
    EventBus.$on('changeRevision', (revision) => {
      this.changeRevision(revision)
    })
  },
  beforeDestroy () {
    EventBus.$off('setupPage')
    EventBus.$off('changeRevision')
  }
}
</script>

<style>
#sumExpenses {
  border-collapse: collapse;
  /* width: 100%; */
}

#sumExpenses td, #sumExpenses th {
  border: 1px solid #ddd;
  padding: 8px;
}

#sumExpenses tr:nth-child(even){background-color: #f2f2f2;}

#sumExpenses tr:hover {background-color: #ddd;}

#sumExpenses th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: var(--v-primary-base);
  color: white;
}
</style>
